"use client";

import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

const PIXEL_ID = "1246037393576685";

function isAllowedPath(pathname) {
  return (
    pathname === "/" ||
    pathname === "/catalog" ||
    pathname.startsWith("/catalog/")
  );
}

export default function MetaPixelLimited() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const allowed = isAllowedPath(pathname);

  // Track previous allowed state so we can revoke when leaving allowed pages
  const prevAllowedRef = useRef(false);

  useEffect(() => {
    const prevAllowed = prevAllowedRef.current;
    prevAllowedRef.current = allowed;

    if (prevAllowed && !allowed && typeof window !== "undefined" && window.fbq) {
      try {
        window.fbq("consent", "revoke");
      } catch (_) {}
    }

    if (allowed && typeof window !== "undefined" && window.fbq) {
      try {
        window.fbq("consent", "grant");
      } catch (_) {}
      window.fbq("track", "PageView");
    }
  }, [allowed, pathname, searchParams]);

  if (!allowed) return null;

  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');

          fbq('consent','grant');
          fbq('init', '${PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>

      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}